import { BlueBar, ActionBar, ButtonsContainer, DropContainer, Left, Right, ModuleName, ButtonsWrapper } from './style';

const Toolbar = {
  BlueBar,
  ActionBar,
  ButtonsContainer,
  DropContainer,
  Left,
  Right,
  ModuleName,
  ButtonsWrapper,
};

export default Toolbar;
